
//Выпилить 

//const prefix_m = "/monoceros";
//const prefix_m = "/";

//для localhost
const prefix_m = "api";
//для боевого
///const prefix_m = "/api"; 
export { prefix_m };


// WEBPACK FOOTER //
// ./src/constant.js